import React from 'react'
import styled from 'styled-components'
import {
  Typography,
  Grid,
  Card,
} from '@material-ui/core'
import * as yup from 'yup'
import {Formik} from 'formik'
import {toast} from 'react-toastify'
import PropTypes from 'prop-types'
import {
  GridItem,
  GRID_CONTAINER_SPACING,
  SaveButton,
  FormikSelect,
} from './common'
import {BOT_GENDER_SETTING_LABEL} from '../../../../../../constant'

const Title = styled(Typography)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`

const SectionCard = styled(Card)`
  padding: 20px;
  margin-bottom: 20px;
`

const BOT_GENDER_TYPE_MENU = [
  {
    label: BOT_GENDER_SETTING_LABEL.BOT_GENDER_LABEL.MALE,
    value: BOT_GENDER_SETTING_LABEL.BOT_GENDER_TYPE.MALE,
  },
  {
    label: BOT_GENDER_SETTING_LABEL.BOT_GENDER_LABEL.FEMALE,
    value: BOT_GENDER_SETTING_LABEL.BOT_GENDER_TYPE.FEMALE,
  },
]

const validationSchema = yup.object({
  botGender: yup.string().matches(/(MALE|FEMALE)/, BOT_GENDER_SETTING_LABEL.SELECT_BOT_GENDER_ERROR),
})

class BotGenderSettingSector extends React.Component {
  render() {
    return (
      <SectionCard>
        <Formik
          enableReinitialize
          initialValues={{
            botGender: this.props.value,
          }}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.projectId,
                  projectInput: {botGender: values.botGender},
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success(
                  BOT_GENDER_SETTING_LABEL.SAVE_SUCCESS,
                  {
                    hideProgressBar: true,
                    position: toast.POSITION.BOTTOM_RIGHT,
                  },
                )
              })
          }}
          validationSchema={validationSchema}
          render={props => {
            const {
              isSubmitting,
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
            } = props
            return (
              <form onSubmit={handleSubmit}>
                <Title variant="title">
                  {BOT_GENDER_SETTING_LABEL.TITLE}
                </Title>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm="auto">
                    <Typography align="center" variant="body1">
                      {BOT_GENDER_SETTING_LABEL.BOT_GENDER}
                    </Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={2}>
                    <FormikSelect
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      value={values.botGender}
                      onChange={handleChange}
                      listItems={BOT_GENDER_TYPE_MENU}
                      name="botGender"
                    />
                  </GridItem>
                  <Grid
                    container
                    direction="row-reverse"
                    spacing={GRID_CONTAINER_SPACING}
                  >
                    <GridItem item xs={12} sm={3}>
                      <SaveButton
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                        fullWidth
                      >
                        {BOT_GENDER_SETTING_LABEL.SAVE}
                      </SaveButton>
                    </GridItem>
                  </Grid>
                </Grid>
              </form>
            )
          }}
        />
      </SectionCard>
    )
  }
}

BotGenderSettingSector.propTypes = {
  value: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
}

export default BotGenderSettingSector



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/BotGenderSettingSector.js